<template>
    <b-container>
        <b-modal
            v-model="openDeleteModal"
            size="xl"
            header-bg-variant="dark"
            header-text-variant="light"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            >
            
            <template v-slot:modal-title>
                <div class="pb-2">Confirmación para Eliminar el Precio Personalizado</div>
            </template>
            <b-row class="my-1 justify-content-md-center">
                <b-col sm="3">
                    <b-img :src="item.imagen" width="200" height="200" fluid alt="Fluid image"></b-img>
                </b-col>
                <b-col sm="5">
                    <div class="pb-2">
                        <label for="input-live"><strong>Código:</strong></label>
                        <b-form-input v-model="item.item_reference" placeholder="Referencia" readonly></b-form-input>
                    </div>
                    <div class="pt-4">
                            <strong>¿Esta seguro de eliminar el item seleccionado? </strong>
                    </div>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
                <b-button variant="danger" @click.prevent="$emit('close-modal')">
                    Cancelar
                </b-button>
                <b-button variant="success" @click.prevent="updatePriceItem(item)">
                    Confirmar
                </b-button>
            </template>
        </b-modal>
    </b-container>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    props: {
        item: {
            type: Object
        },
        openDeleteModal: {
            type: Boolean
        }
    },
    methods:{
        ...mapMutations(['setLoading']),
        async updatePriceItem(datos){
            this.setLoading(true)
            let data   = {item_id: datos.id}
            await this.$conectar.post('/admin/recommended-items/delete-item', data)
            .then(response =>{
                if (response.data.error == false) { 
                    this.$emit('close-delete-modal');
                    this.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                }else{
                    this.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(error => {
                this.$bvToast.toast("Parece que hubo un error en el servidor", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                console.log(error);
            })
            this.setLoading(false)
        },
        
    }
}
</script>